"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCoordinatesFromMouseEvent = exports.areRecordsEqual = void 0;
var tslib_1 = require("tslib");
var areRecordsEqual = function (recordA, recordB) {
    var e_1, _a;
    if ((!recordA && !!recordB) || (!!recordA && !recordB)) {
        return false;
    }
    if (recordA === recordB) {
        return true;
    }
    var keysA = Object.keys(recordA);
    var keysB = Object.keys(recordB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    try {
        for (var keysA_1 = tslib_1.__values(keysA), keysA_1_1 = keysA_1.next(); !keysA_1_1.done; keysA_1_1 = keysA_1.next()) {
            var keyName = keysA_1_1.value;
            if (recordA[keyName] !== recordB[keyName]) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (keysA_1_1 && !keysA_1_1.done && (_a = keysA_1.return)) _a.call(keysA_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};
exports.areRecordsEqual = areRecordsEqual;
var getCoordinatesFromMouseEvent = function (event) { return ({ x: event.clientX, y: event.clientY }); };
exports.getCoordinatesFromMouseEvent = getCoordinatesFromMouseEvent;
//# sourceMappingURL=utils.js.map